module.exports = __webpack_public_path__ + "static/media/prick_HMPG_ashley_image_600M.c442ca15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/prick_HMPG_ashley_image_600M.jpg
// module id = 354
// module chunks = 0